import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { filter, get, includes, uniqBy, sortBy, cloneDeep } from 'lodash';
import { push } from 'connected-react-router';
import compose from 'recompose/compose';
import { Button, Link, withStyles, Grid } from '@material-ui/core';
import { getI18n } from '../../../../utils/intl';
import { useIntl } from 'react-intl';
import { array, arrayOf, bool, func, object, string } from 'prop-types';
import { APPLICATION_REQUEST_FAILED_MORE_INFO } from '../labels';

import {
  AlertDialog,
  AlertMessages, Footer, FormTextField, HelpContainer,
  LoadingDialog,
} from '../../../../components';
import {
  fetchListDetails,
  fetchRequestDetails,
  submitRequest,
  reviewApplication,
  withdrawRequest,
} from '../../../../actions/requests';
import {
  getAppReviewUpdateStatus,
  getErrors,
  getDetailsListResults,
  getRequestDetails,
  getRequestUpdateStatus,
  getAppReviewResponse,
  getAppWithdrawStatus,
  getOperationLoading,
} from '../../../../reducers/request';
import { getFeatureFlagApiPlans } from '../../../../reducers/portalConfig';
import styles from './styles';
import { RequestSectionTable, MultiRequestTable } from './SectionTable';
import {
  buildDetailsData,
  buildEditRequestTable,
  buildEditApisRequestTable,
  buildSingleApplicationRequestMap,
  getTableColumns,
  buildCertificatesData,
  getMultiRequestTableColumns,
  buildEditProductsRequestTable,
} from '../../../Requests/AppRequestDetails/utils';
import { ALERT_SUCCESS, SUCCESS, ALERT_ERROR, FAIL, getOrgBoundRoles } from '../../../../constants';
import { getUserDetails } from '../../../../reducers/portalConfig';

export const Requests = (props) => {
  const {
    classes,
    listResults,
    requestDetails,
    requestUpdateStatus,
    appReviewUpdateStatus,
    errors,
    applicationUuid,
    apiPlansEnabled,
    appReviewResponse,
    isCurrentTab,
    isAdmin,
    isPublisherRole,
    isOrgPublisherRole,
    appWithdrawStatus,
    addEditPendingApiKey,
    operationLoading,
  } = props;

  const orderList = ["registration", "status", "addinfo", "details", "drydetails",
    "customfields", "apis", "apiplans", "apigroups", "products", "apikeys", "certificates", "oauthclients"];
  const [notificationMessage, setNotificationMessage] = useState(localStorage.getItem('notificationMessage'));
  const [notificationStatus, setNotificationStatus] = useState(localStorage.getItem('notificationStatus'));
  const [requestDetailsMap, setRequestDetailsMap] = useState({});
  const [requestType, setRequestType] = useState('');
  const [reviewRequestType, setReviewRequestType] = useState('');
  const [apisRequestDetails, setApisRequestDetails] = useState([]);
  const [productsRequestDetails, setProductsRequestDetails] = useState([]);
  const [requestDetailsCount, setRequestDetailsCount] = useState(0);
  const [requestInfoMap, setRequestInfoMap] = useState({});
  const [singleRequest, setSingleRequest] = useState(false);
  const [showActionAlert, setShowActionAlert] = useState(false);
  const [showActionAlertMoreInfo, setShowActionAlertMoreInfo] = useState(false);
  const [actionType, setActionType] = useState('');
  const [uuidType, setUuidType] = useState('');
  const [actionUuid, setActionUuid] = useState('');
  const [actionTable, setActionTable] = useState('');
  const [pendingRequestCount, setPendingRequestCount] = useState(-1);
  const [actionTableMap, setActionTableMap] = useState({});
  const [alertReason, setAlertReason] = useState('');
  const [detailsRequestExist, setDetailsRequestExist] = useState(true);
  const [singleRequestUuid, setSingleRequestUuid] = useState('');
  const intl = getI18n(useIntl());
  const [assignedOrg, setAssignedOrg] = useState({ uuid: '', name: '' });
  const [assignedOrgSearchText, setAssignedOrgSearchText] = useState('');
  const assignRoleOptions = getOrgBoundRoles(intl);
  const [assignedRole, setAssignedRole] = useState(assignRoleOptions[0].uuid);
  const [shouldNotifyUser, setShouldNotifyUser] = useState(false);
  const [hasRequests, setHasRequests] = useState(true);
  const [showOAuthClientDetails, setShowOAuthClientDetails] = useState(null);

  const { getI18nMessage } = intl;
  const entityUuid = applicationUuid;

  useEffect(() => {
    if (applicationUuid) {
      props.fetchListDetails({ entityUuid: applicationUuid });
    }
  }, [applicationUuid]);

  useEffect(() => {
    if (isCurrentTab) {
      props.fetchListDetails({ entityUuid: applicationUuid });
      notifyMessages('', '');
    }
  }, [isCurrentTab]);

  useEffect(() => {
    if (listResults) {
      if (listResults.length > 0) {
        setHasRequests(true);
        const firstRequest = listResults[0];
        const reqType = get(firstRequest, 'requestType');
        const reqSubtype = get(firstRequest, 'requestSubtype');
        const reqSubType = get(firstRequest, 'requestSubtype');
        if (reqType === 'APPLICATION' ||
          (reqType === 'APPLICATION_DETAILS' && reqSubType === 'APP_STATUS_CHANGE')) {
          setSingleRequest(true);
          setRequestType(reqSubtype === 'DELETE' || reqSubtype === 'UPDATE' ? `APPLICATION_${reqSubType}` : reqType);
          setSingleRequestUuid(firstRequest.uuid);
        } else {
          setDetailsRequestExist(listResults.find(req => req.requestType === 'APPLICATION_DETAILS'));
          setRequestType('APPLICATION_EDIT');
        }
        setPendingRequestCount(listResults.length);
        if (reqType !== 'REGISTRATION') {
          listResults.map(req => props.fetchRequestDetails(req.uuid));
        }
      } else {
        setHasRequests(false);
      }
    }
  }, [listResults]);
  useEffect(() => {
    if (requestDetails && requestDetails.request) {
      setRequestDetailsCount(requestDetailsCount + 1);
      const reqType = requestDetails.request.requestType;
      if (reqType === 'APPLICATION') {
        setRequestDetailsMap(buildSingleApplicationRequestMap(classes, requestDetails));
      } else {
        //Added for apis and apisPlans
        if (reqType === "PATCH_APPLICATION_API_PLANS" || reqType === "PATCH_APPLICATION_APIS") {
          const obj = apisRequestDetails;
          obj.push(requestDetails);
          setApisRequestDetails(obj);
        } else if (reqType === 'PATCH_APPLICATION_PRODUCTS') {
          const obj = productsRequestDetails;
          obj.push(requestDetails);
          setProductsRequestDetails(obj);
        } else if (reqType === 'APPLICATION_CERTIFICATES') {
          setRequestDetailsMap({
            ...requestDetailsMap,
            ['certificates']: [
              ...requestDetailsMap['certificates'] || [],
              buildCertificatesData(requestDetails),
            ],
            drydetails:
              buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
          });
        } else if (reqType === 'APPLICATION_API_KEYS') {
          if (requestDetails.request.requestSubtype !== 'CREATE') {
            const apiKeys = get(requestDetails, 'original.applicationApiKeys');
            if (apiKeys) {
              addEditPendingApiKey(get(apiKeys[0], 'apiKey'));
            }
          }
          const { dataTable } = buildEditRequestTable(classes, requestDetails) || {};
          let existingKeys = cloneDeep(requestDetailsMap['apikeys']) || [];
          // if a key is already added for this request, remove it
          existingKeys = filter(existingKeys, item => item.uuid !== requestDetails.request.uuid);
          setRequestDetailsMap({
            ...requestDetailsMap,
            ['apikeys']: [
              ...existingKeys,
              {
                ...requestDetails.request,
                requestEntities: dataTable,
              },
            ],
            drydetails:
              buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
          });
        } else if (reqType === 'APPLICATION_OAUTH_CLIENTS') {

          if (requestDetails.request.requestSubtype !== 'CREATE') {
            const oauthClients = get(requestDetails, 'original.applicationOAuthClients');
            if (oauthClients && oauthClients.length) {
              addEditPendingApiKey(get(oauthClients[0], 'clientId'));
            }
          }

          const { dataTable } = buildEditRequestTable(classes, requestDetails) || {};
          let existingKeys = cloneDeep(requestDetailsMap['oauthclients']) || [];
          // if a key is already added for this request, remove it
          existingKeys = filter(existingKeys, item => item.uuid !== requestDetails.request.uuid);

          setRequestDetailsMap({
            ...requestDetailsMap,
            ['oauthclients']: [
              ...existingKeys,
              {
                ...requestDetails.request,
                requestEntities: dataTable,
              },
            ],
            drydetails:
              buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
          });
        } else {
          const { type, dataTable } = buildEditRequestTable(classes, requestDetails);
          if (requestDetails.request.requestSubtype === 'APP_STATUS_CHANGE') {
            setRequestDetailsMap({
              ...requestDetailsMap,
              [type]: dataTable,
              ['addinfo']: buildDetailsData(classes, requestDetails.original.applicationDetails, null, true),
            });
          } else {
            if (!requestDetailsMap['details'] && !detailsRequestExist) {
              setRequestDetailsMap({
                ...requestDetailsMap,
                [type]: dataTable,
                drydetails:
                  buildDetailsData(classes, requestDetails.applicationExcerpt, null, false),
              });
            } else {
              setRequestDetailsMap({
                ...requestDetailsMap,
                [type]: dataTable,
              });
            }
          }
          setRequestInfoMap({
            ...requestInfoMap,
            [type]: requestDetails.request,
          });
        }
      }
    }
  }, [requestDetails]);
  useEffect(() => {
    let requestDetailsObject = {};
    if (listResults && requestDetailsCount === listResults.length && !singleRequest) {
      if (apisRequestDetails.length > 0) {
        const { type, dataTable } = buildEditApisRequestTable(apisRequestDetails, apiPlansEnabled);
        let apisTable = uniqBy(dataTable, 'uuid');
        apisTable = sortBy(apisTable, 'modifyTs').reverse();
        //Added code for app requestDetails.request.requestSubtype === 'APP_STATUS_CHANGE'
        if (!requestDetailsMap['details'] && !detailsRequestExist) {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: apisTable,
            drydetails:
              buildDetailsData(classes, apisRequestDetails[0].applicationExcerpt, null, false),
          };
        } else {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: dataTable,
          };
        }
      }
      if (productsRequestDetails.length > 0) {
        const { type, dataTable } = buildEditProductsRequestTable(productsRequestDetails);
        let productsTable = uniqBy(dataTable, 'uuid');
        productsTable = sortBy(productsTable, 'modifyTs').reverse();
        if (!requestDetailsMap['details'] && !detailsRequestExist) {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: productsTable,
            drydetails:
              buildDetailsData(classes, productsRequestDetails[0].applicationExcerpt, null, false),
          };
        } else {
          requestDetailsObject = {
            ...requestDetailsObject,
            [type]: productsTable,
          };
        }
      }
      setRequestDetailsMap({
        ...requestDetailsMap,
        ...requestDetailsObject,
      });
    }
  }, [requestDetailsCount, listResults, apisRequestDetails, requestDetails, productsRequestDetails])
  useEffect(() => {
    if (requestUpdateStatus) {
      setShowActionAlert(false);
      setAlertReason('');
      if (singleRequest) {
        if (requestUpdateStatus === SUCCESS) {
          const message = intl.getI18nMessage(`label.application.details.section.${actionType}.success`);
          localStorage.setItem('notificationStatusRequestSaveSuccess', ALERT_SUCCESS);
          localStorage.setItem('notificationMessageRequestSaveSuccess', message);
          notifyMessages(message, ALERT_SUCCESS);
          window.location.reload();
        } else if (requestUpdateStatus === FAIL) {
          let errorMsg = appendGetMoreInfoLink(intl.getI18nMessage(`label.application.details.section.${actionType}.error`));
          if (errors && errors.length > 0 && errors[0].field === 'keyStoreCheck') {
            errorMsg = errors[0].error;
          }
          notifyMessages(errorMsg, ALERT_ERROR);
        }
      } else {
        if (requestUpdateStatus === SUCCESS) {
          if (pendingRequestCount === 1) {
            const message = intl.getI18nMessage(`label.application.details.section.${actionType}.all.success`);
            localStorage.setItem('notificationStatusRequestSaveSuccess', ALERT_SUCCESS);
            localStorage.setItem('notificationMessageRequestSaveSuccess', message);
            notifyMessages(message, ALERT_SUCCESS);
            window.location.reload();
          } else {
            setPendingRequestCount(pendingRequestCount - 1);
            window.location.reload();
          }
        } else if (requestUpdateStatus === FAIL) {
          let errorMsg = appendGetMoreInfoLink(intl.getI18nMessage(`label.application.details.section.${actionType}.error`));
          if (errors && errors.length > 0 && errors[0].field === 'keyStoreCheck') {
            errorMsg = errors[0].error;
          }
          notifyMessages(errorMsg, ALERT_ERROR);
        }
        setActionTableMap({
          ...actionTableMap,
          [actionTable]: {
            status: requestUpdateStatus,
            actionType: actionType,
          },
        });
      }
    }
  }, [requestUpdateStatus]);
  useEffect(() => {
    if (appWithdrawStatus) {
      if (appWithdrawStatus === SUCCESS) {
        const message = intl.getI18nMessage(`label.application.details.section.withdraw.success`);
        notifyMessages(message, ALERT_SUCCESS);
        window.location.reload();
      } else if (appWithdrawStatus === FAIL) {
        let errorMsg;
        if (errors && errors.length > 0) {
          errorMsg = errors[0].error;
        }
        errorMsg = errorMsg ? errorMsg : appendGetMoreInfoLink(intl.getI18nMessage(`label.application.details.section.withdraw.error`));
        notifyMessages(errorMsg, ALERT_ERROR);
      }
    }
  }, [appWithdrawStatus]);
  useEffect(() => {
    setShowActionAlert(false);
    if (get(appReviewResponse, 'hasErrors') && appReviewUpdateStatus === SUCCESS) {
      const message = get(appReviewResponse, 'action') === 'ACCEPT'
        ? intl.getI18nMessage(`label.application.details.section.accept.failed`) :
        intl.getI18nMessage(`label.application.details.section.reject.failed`);
      props.fetchListDetails({ entityUuid: applicationUuid });
      notifyMessages(appendGetMoreInfoLink(message), ALERT_ERROR);
    } else if (appReviewUpdateStatus === SUCCESS) {
      notifyMessages(intl.getI18nMessage('label.application.details.section.accept.all.success'), ALERT_SUCCESS);
      window.location.reload();
    } else if (appReviewUpdateStatus === FAIL) {
      const message = appendGetMoreInfoLink(intl.getI18nMessage(`label.application.details.section.${actionType}.all.error`));
      notifyMessages(message, ALERT_ERROR);
    }
  }, [appReviewUpdateStatus]);

  const appendGetMoreInfoLink = (message) => <>{`${message}`} {getMoreInfoLink(onClickGetMoreInfoLink)}</>

  const notifyMessages = (message, status, timeout) => {
    setNotificationStatus(status);
    setNotificationMessage(message);
    if (status === ALERT_SUCCESS) {
      localStorage.setItem('notificationStatus', status);
      localStorage.setItem('notificationMessage', message);
    }
    if (timeout) {
      setTimeout(() => {
        notifyMessages('', '');
      }, 3000);
    }
  };
  const reviewEntityRequest = (action) => {
    if (singleRequest) {
      setUuidType('REQUEST');
      setActionUuid(singleRequestUuid);
    } else {
      setUuidType('ENTITY');
      setActionUuid(entityUuid);
    }
    setActionType(action);
    setShowActionAlert(true);
  }
  const review = (uuidType, action, uuid, actionTable, reviewRequestType) => {
    setUuidType(uuidType);
    setActionType(action);
    setActionUuid(uuid);
    setActionTable(actionTable);
    setShowActionAlert(true);
    setReviewRequestType(reviewRequestType);
  };
  const submitReview = () => {
    if (uuidType === 'ENTITY' || reviewRequestType) {
      props.reviewApplication(actionUuid, actionType, alertReason, reviewRequestType);
    } else {
      setReviewRequestType('');
      const payload = {
        isAccept: actionType === 'accept',
        requestId: actionUuid,
        reason: alertReason ? alertReason : '',
      }
      props.submitRequest(payload);
    }
  };

  const onWithdraw = (requestUuid) => {
    props.withdrawRequest(requestUuid)
  }

  const onAssignedOrgChange = (org = {}) => {
    if (!org) org = { uuid: '', name: '' }
    setAssignedOrg(org);
    setAssignedOrgSearchText(org.name);
  };

  const onClickTableValue = () => {
    reviewEntityRequest('accept')
  }

  const onAssignedRoleChange = (role) => setAssignedRole(role);
  const onShouldNotifyUserChange = () => setShouldNotifyUser(shouldNotifyUser => !shouldNotifyUser)
  const onAlertReasonChange = (reason) => setAlertReason(reason)

  const getAlertDialogInnerComponent = () => {
    return <AlertDialogInnerComponent
      classes={classes}
      requestType={requestType}
      isAcceptAction={actionType === 'accept'}
      getI18nMessage={getI18nMessage}
      assignedOrgSearchText={assignedOrgSearchText}
      assignedOrg={assignedOrg}
      onAssignedOrgChange={onAssignedOrgChange}
      assignedRole={assignedRole}
      onAssignedRoleChange={onAssignedRoleChange}
      assignRoleOptions={assignRoleOptions}
      shouldNotifyUser={shouldNotifyUser}
      onShouldNotifyUserChange={onShouldNotifyUserChange}
      alertReason={alertReason}
      onAlertReasonChange={onAlertReasonChange}
    />
  }

  const getAlertDialogInnerComponentMoreInfo = () => {
    return <HelpContainer
      helpItems={APPLICATION_REQUEST_FAILED_MORE_INFO.details}
      containerClass={classes.helpContainerClass}
    />
  }

  const onClickGetMoreInfoLink = () => {
    setShowActionAlertMoreInfo(true)
    notifyMessages('', '');
  }

  const getMoreInfoLink = (onClickHandler) =>
    <Link variant="inherit" onClick={onClickHandler}>
      {intl.getI18nMessage('label.application.details.section.failed.more.info')}
    </Link>

  const onAlertDialogClose = () => {
    setShouldNotifyUser(false);
    setShowActionAlert(false);
  }

  const colCallback = (data) => {
    setShowOAuthClientDetails(JSON.stringify(JSON.parse(data), null, 2));
  }
  const closeOAuthClientDetails = () => {
    setShowOAuthClientDetails(null);
  }

  const getOAuthDialogContent = (value) => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <FormTextField
            id='auth-provider-client-defn-metadata-field'
            value={value}
            rows={30}
            multiline={true}
            onChange={()=>{}}
            disabled
            fieldContainerClass={classes.textFieldContainer}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <div className={classes.content}
        id="request-details-page" data-apim-test="request-details-page"
      >
        {showOAuthClientDetails &&
          <AlertDialog
            id="request-oauth-client-details-dialog"
            data-apim-test="request-oauth-client-details-dialog"
            isOpen={showOAuthClientDetails}
            onClose={closeOAuthClientDetails}
            onCancel={closeOAuthClientDetails}
            showCloseButton={true}
            showSubmit={false}
            showCancel={true}
            cancelText={intl.getI18nMessage('label.close.button')}
            title={intl.getI18nMessage('label.auth.providers.details.sample.client.definition.metadata')}
            component={getOAuthDialogContent(showOAuthClientDetails)}
          />
        }
        {notificationMessage &&
          <AlertMessages
            id="app-details-notification"
            hasNotificationIcon={true}
            hasAction={true}
            variant={notificationStatus}
            message={notificationMessage}
            containerClass={classes.alertMessages}
            actionButtonClass={classes.alertMessagesCloseButton}
            onClose={() => { notifyMessages('', ''); }}
          />
        }
        <LoadingDialog
          className={classes.genericLoadingDialog}
          isOpen={operationLoading}
          title={intl.getI18nMessage('label.api.key.generic.loading.title')}
          description={intl.getI18nMessage('label.api.key.generic.loading.text')}
          dialogId="generic-loading-dialog"
        />
        {!hasRequests &&
          <div className={classes.noResults}>
            {intl.getI18nMessage('label.request.no.results')}
          </div>
        }
        <AlertDialog
          id="request-detail-error-more-info-dialog"
          data-apim-test="request-detail-error-more-info-dialog"
          isOpen={showActionAlertMoreInfo}
          showDefault={true}
          showSubmit={false}
          showCancel={false}
          defaultText={intl.getI18nMessage('label.close.button')}
          title={intl.getI18nMessage('label.application.details.section.failed.more.info.dialog.title')}
          component={getAlertDialogInnerComponentMoreInfo()}
          onDefault={() => setShowActionAlertMoreInfo(false)}
        />
        <AlertDialog
          id="request-detail-accept-reject-dialog"
          data-apim-test="request-detail-accept-reject-dialog"
          isOpen={showActionAlert}
          title={intl.getI18nMessage(`label.request.list.actions.alert.${actionType}.title`)}
          description={intl.getI18nMessage('label.request.list.actions.alert.description')}
          disableSubmit={actionType === 'reject' && (!alertReason || !alertReason.trim())}
          submitText={intl.getI18nMessage(`label.request.list.actions.${actionType}`)}
          cancelText={intl.getI18nMessage('label.cancel.button')}
          component={showActionAlert && getAlertDialogInnerComponent()}
          onClose={onAlertDialogClose}
          onSubmit={() => submitReview()}
          onCancel={onAlertDialogClose}
          submitButtonClass={actionType === 'accept' ? '' : classes.rejectSubmitButton}
        />
        <div className={classes.header}>
          <div className={classes.sectionHead}>
            {(((singleRequest || pendingRequestCount > 0)
              && (isOrgPublisherRole || isPublisherRole)) ||
              ((get(requestDetails, 'request.requestSubtype') === 'CREATE') &&
                get(requestDetails, 'request.requestType') === 'APPLICATION') && (isOrgPublisherRole || isPublisherRole)) &&
              <div className={classes.pageButtonDiv}>
                <Button
                  id="accept-button"
                  data-apim-test="accept-button"
                  variant="contained"
                  color="secondary"
                  className={classes.acceptButton}
                  onClick={() => reviewEntityRequest('accept')}
                >
                  {intl.getI18nMessage(`label.application.details.section.accept.${singleRequest ? '' : 'all.'}button`)}
                </Button>
                <Button
                  id="reject-button"
                  data-apim-test="reject-button"
                  className={classes.rejectButton}
                  onClick={() => reviewEntityRequest('reject')}
                >
                  {intl.getI18nMessage(`label.application.details.section.reject.${singleRequest ? '' : 'all.'}button`)}
                </Button>
              </div>
            }
          </div>
        </div>
        {orderList.filter(type => Object.keys(requestDetailsMap).includes(type)).map(key => {
          if (includes(['apikeys', 'apiplans', 'apis', 'certificates', 'products', 'oauthclients'], key) && requestDetailsMap[key].length > 0 &&
            (get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_APIS'
              || get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_API_PLANS'
              || get(requestDetailsMap[key][0], 'requestType') === 'APPLICATION_CERTIFICATES'
              || get(requestDetailsMap[key][0], 'requestType') === 'APPLICATION_API_KEYS'
              || get(requestDetailsMap[key][0], 'requestType') === 'PATCH_APPLICATION_PRODUCTS'
              || get(requestDetailsMap[key][0], 'requestType') === 'APPLICATION_OAUTH_CLIENTS')) {
            return (
              <MultiRequestTable
                key={key}
                sectionType={key}
                columns={getMultiRequestTableColumns(classes, singleRequest && requestType !== 'APPLICATION_UPDATE', key, isAdmin, requestType, colCallback)}
                rows={requestDetailsMap[key]}
                onReview={review}
                classes={classes}
                user={props.user}
                entityUuid={entityUuid}
                apisRequestDetails={apisRequestDetails}
                isAdmin={isAdmin}
                isPublisherRole={isPublisherRole}
                isOrgPublisherRole={isOrgPublisherRole}
                onWithdraw={onWithdraw}
                hasRowHeader={['apikeys', 'apis', 'apiplans', 'products', 'oauthclients'].includes(key)}
              />
            )
          } else {
            return (
              <RequestSectionTable
                key={key}
                sectionType={key}
                columns={getTableColumns(classes, singleRequest && requestType !== 'APPLICATION_UPDATE', key, onClickTableValue, isAdmin, requestType, colCallback)}
                rows={requestDetailsMap[key]}
                requestInfo={requestInfoMap[key]}
                actionStatus={actionTableMap[key]}
                onReview={review}
                classes={classes}
                user={props.user}
                isAdmin={isAdmin}
                isPublisherRole={isPublisherRole}
                isOrgPublisherRole={isOrgPublisherRole}
                onWithdraw={onWithdraw}
              />
            )
          }
        })}
        <Footer />
      </div>
    </Fragment>
  );
};

export const AlertDialogInnerComponent = (props) => {
  const {
    classes,
    isAcceptAction,
    getI18nMessage,
    alertReason,
    onAlertReasonChange,
  } = props;
  return (
    <div>
      <FormTextField
        fieldContainerClass={classes.alertMessageContainerClass}
        maxLength={1000}
        multiline
        handleChange={(value) => onAlertReasonChange(value)}
        placeholder={getI18nMessage(`label.request.list.actions.alert.${isAcceptAction ? 'accept' : 'reject'}.placeholder`)}
        rows={4}
        textFieldClass={classes.alertMessageClass}
        value={alertReason}
      />
      <div className={classes.alertMessageMaxLengthWarningClass}>
        {getI18nMessage('label.request.list.actions.alert.max.length.warning')}
      </div>
    </div>
  );
};

AlertDialogInnerComponent.propTypes = {
  classes: object,
  onAssignedRoleChange: func,
  assignRoleOptions: array,
  shouldNotifyUser: bool,
  onShouldNotifyUserChange: func,
  alertReason: string,
  onAlertReasonChange: func,
  getI18nMessage: func,
  isAcceptAction: bool,
}

const mapStateToProps = state => ({
  listResults: getDetailsListResults(state),
  requestDetails: getRequestDetails(state),
  requestUpdateStatus: getRequestUpdateStatus(state),
  appReviewUpdateStatus: getAppReviewUpdateStatus(state),
  user: getUserDetails(state),
  errors: getErrors(state),
  apiPlansEnabled: getFeatureFlagApiPlans(state),
  appReviewResponse: getAppReviewResponse(state),
  appWithdrawStatus: getAppWithdrawStatus(state),
  operationLoading: getOperationLoading(state),
});

const mapDispatchToProps = {
  fetchListDetails,
  fetchRequestDetails,
  submitRequest,
  reviewApplication,
  withdrawRequest,
  push,
};

Requests.propTypes = {
  fetchListDetails: func,
  requestDetails: object,
  fetchRequestDetails: func,
  listResults: arrayOf(object),
  getListResults: func,
  classes: object,
  requestUpdateStatus: string,
  appReviewUpdateStatus: string,
  submitRequest: func,
  reviewApplication: func,
  push: func,
  user: object,
  errors: arrayOf(object),
  applicationUuid: string,
  apiPlansEnabled: bool,
  appReviewResponse: object,
  isAdmin: bool,
  isCurrentTab: bool,
  appWithdrawStatus: string,
  withdrawRequest: func,
  isPublisherRole: bool,
  isOrgPublisherRole: bool,
  addEditPendingApiKey: func,
  operationLoading: bool,
};


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Requests);
